import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import LoginScreen from './component'
import Overlay from '../../Atoms/Overlay'
import { extractQueryParams } from '../../../lib/extract-query-params'

import { login } from '../../../redux/auth'

import AdminApi from '../../../services/admin-api'

class LoginContainer extends PureComponent {
  constructor () {
    super()
    const params = extractQueryParams()
    this.state = {
      environment: params.environment || null,
      events: [],
      isFetchingEvents: false,
      errorFetchingEvents: null,
      selectedEventId: null
    }
  }

  componentDidUpdate (prevProps) {
    if (
      !prevProps.isLoggedIn && this.props.isLoggedIn
    ) {
      this.props.navigation.navigate('App')
    }
  }

  handleLogin = ({ email, password, eventId }) => {
    this.props.login({
      email,
      password,
      environment: this.state.environment,
      eventId
    })
  }

  fetchEvents = async ({ email }) => {
    this.setState({ isFetchingEvents: true, events: [], errorFetchingEvents: null })
    try {
      const events = await AdminApi.getEvents({ environment: this.state.environment, email })
      const selectedEventId = events.length === 1 ? events[0].id : null
      this.setState({ events, isFetchingEvents: false, selectedEventId })
    } catch (e) {
      let error = e
      if (e.message === 'Invalid url path parameters') {
        error = new Error('email: should be a valid email address')
      }
      this.setState({ isFetchingEvents: false, errorFetchingEvents: error })
    }
  }

  handleClearEmail = () => {
    this.setState({ events: [], selectedEventId: null })
  }

  render () {
    return (
      <Overlay>
        <LoginScreen
          onLogin={this.handleLogin}
          error={this.props.error}
          isLoading={this.props.isLoading}
          events={this.state.events}
          fetchEvents={this.fetchEvents}
          isFetchingEvents={this.state.isFetchingEvents}
          errorFetchingEvents={this.state.errorFetchingEvents}
          selectedEventId={this.state.selectedEventId}
          onClearEmail={this.handleClearEmail}
        />
      </Overlay>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.auth.isLoading,
    isLoggedIn: state.auth.isLoggedIn,
    error: state.auth.error
  }
}

export default connect(mapStateToProps, {
  login
})(LoginContainer)
